import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header/Header';
import FeaturedProjects from '../components/FeaturedProjects/FeaturedProjects';
import BlogCTA from '../components/BlogCTA/BlogCTA';
import './Blog.css';

const blogPosts = [
  { id: 1, title: "5 Signs Your Home Needs Electrical Rewiring", date: "April 15, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-1.jpg", excerpt: "Is your home showing signs of electrical problems? Here are 5 warning signs.", category: "Electrical Tips" },
  { id: 2, title: "Benefits of Installing Solar Panels in Kenya", date: "April 10, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-2.jpg", excerpt: "Discover how solar energy can save you money and provide reliable power.", category: "Solar Energy" },
  { id: 3, title: "Choosing the Right CCTV System", date: "April 5, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-3.jpg", excerpt: "A comprehensive guide to selecting the best security camera system.", category: "Security" },
  { id: 4, title: "Electrical Safety Tips Every Homeowner Should Know", date: "March 28, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-4.jpg", excerpt: "Essential electrical safety practices to protect your family and property.", category: "Safety" },
  { id: 5, title: "The Future of Smart Home Technology", date: "March 20, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-5.jpg", excerpt: "Explore how smart home technology is transforming living spaces across Kenya.", category: "Technology" },
  { id: 6, title: "Cost Guide: Electrical Installation in New Buildings", date: "March 15, 2026", author: "Musa Electrical Team", image: "/images/blog/blog-6.jpg", excerpt: "Understanding the costs involved in electrical installation for new projects.", category: "Guides" }
];

const Blog = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const latestPosts = blogPosts.slice(0, 3);
  const recentPosts = blogPosts.slice(1, 5);

  useEffect(() => {
    const interval = setInterval(() => setCurrentSlide(prev => (prev + 1) % latestPosts.length), 5000);
    return () => clearInterval(interval);
  }, [latestPosts.length]);

  return (
    <div className="page-wrapper">
      <div className="hero-wrapper">
        <Header />
        <div className="page-hero">
          <div className="page-hero-overlay"></div>
          <div className="page-hero-content">
            <h1>Our Blog</h1>
            <p>Tips, guides, and insights from electrical professionals</p>
            <div className="breadcrumb">
              <a href="/">Home</a><span className="sep">/</span>
              <span className="active">Blog</span>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-container">
        <div className="blog-row">
          <div className="blog-left">
            <div className="blog-slider">
              <div className="slider-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                {latestPosts.map((post) => (
                  <div className="slider-slide" key={post.id}>
                    <div className="slider-bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + post.image})` }}>
                      <div className="slider-overlay" />
                      <div className="slider-content">
                        <span className="slider-category">{post.category}</span>
                        <h2>{post.title}</h2>
                        <p>{post.excerpt}</p>
                        <div className="slider-meta"><span>{post.date}</span><span>By {post.author}</span></div>
                        <Link to={`/blog/${post.id}`} className="slider-btn">Read More →</Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="slider-dots">
              {latestPosts.map((_, i) => (
                <button key={i} className={`dot ${i === currentSlide ? 'active' : ''}`} onClick={() => setCurrentSlide(i)} />
              ))}
            </div>
          </div>

          <div className="blog-right">
            <div className="recent-title">Recent Posts</div>
            <div className="recent-grid">
              {recentPosts.map((post) => (
                <Link to={`/blog/${post.id}`} className="recent-card" key={post.id}>
                  <div className="recent-bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + post.image})` }}>
                    <div className="recent-overlay">
                      <span className="recent-category">{post.category}</span>
                      <h4>{post.title}</h4>
                      <span className="recent-date">{post.date}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            <Link to="/blog/all-posts" className="view-all-btn">View All Posts →</Link>
          </div>
        </div>

        <div className="blog-featured-section">
          <FeaturedProjects />
        </div>
      </div>

      {/* CTA + Subscribe */}
      <BlogCTA />
    </div>
  );
};

export default Blog;
